import { type DependencyList, type EffectCallback, useEffect, useRef } from 'react';

type UseSecondEffect = (effect: EffectCallback, deps?: DependencyList) => void;

const useSecondEffect: UseSecondEffect = (effect, deps) => {
  const isFirstRun = useRef(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: isFirstRun ref is intentionally excluded — it's a stable ref, not a dep
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;

      return;
    }

    effect();
  }, deps);
};

export default useSecondEffect;
